/* ==========================================================================
   TanneryNYC — guided inquiry flow

   Multi-instance safe: initialises every [data-tnq] on the page independently.

   Design notes worth keeping in mind before editing:

   1. There is ONE form. Steps are visibility groups, so the POST that leaves
      the browser is identical to the old single-page form — same contact[...]
      names, same endpoint. Nothing here serialises or re-assembles state.

   2. Confirmation waits for the target iframe to LOAD, not for the submit
      event. The previous implementation showed "we received your request" the
      instant submit fired, so a rejected post looked identical to a successful
      one and the lead disappeared without anyone knowing. If the iframe never
      loads within TIMEOUT_MS we show a failure state with a mailto instead.
      Do not "simplify" this back to firing on submit.
   ========================================================================== */

(function () {
  'use strict';

  var TIMEOUT_MS = 12000;
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  function init(root) {
    if (root.__tnqReady) return;
    root.__tnqReady = true;

    var form = root.querySelector('[data-tnq-form]');
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-tnq-panel]'));
    if (!form || !panels.length) return;

    var stepEl = root.querySelector('[data-tnq-step]');
    var fill = root.querySelector('[data-tnq-fill]');
    var back = root.querySelector('[data-tnq-back]');
    var next = root.querySelector('[data-tnq-next]');
    var hint = root.querySelector('[data-tnq-hint]');
    var allBtn = root.querySelector('[data-tnq-all]');
    var recapRows = root.querySelector('[data-tnq-recap-rows]');
    var done = root.querySelector('[data-tnq-done]');
    var fail = root.querySelector('[data-tnq-fail]');
    var frame = document.getElementsByName(form.getAttribute('target'))[0];

    var i = 0;
    var showAll = false;
    var total = panels.length;
    var sendLabel = next.getAttribute('data-send') || 'Send inquiry';
    var pending = false;
    var timer = null;

    function cur() { return panels[i]; }
    function isLast() { return i === total - 1; }

    function choiceText(btn) {
      var t = btn.querySelector('.tnq__choice-t');
      return t ? t.textContent.trim() : btn.textContent.trim();
    }

    function valid(p) {
      if (p.getAttribute('data-req') !== '1') return true;

      if (p.querySelector('[data-tnq-choices]')) {
        var h = p.querySelector('[data-tnq-value]');
        return !!(h && h.value);
      }

      var reqs = Array.prototype.slice.call(p.querySelectorAll('[required]'));
      return reqs.every(function (f) {
        if (!f.value.trim()) return false;
        if (f.type === 'email') return EMAIL_RE.test(f.value.trim());
        return true;
      });
    }

    function label(p) {
      var h = p.querySelector('.tnq__q');
      return h ? h.textContent.trim().replace(/\?$/, '') : '';
    }

    function answer(p) {
      if (p.querySelector('[data-tnq-choices]')) {
        var h = p.querySelector('[data-tnq-value]');
        return h ? h.value : '';
      }
      var f = p.querySelector('input:not([type=hidden]), textarea');
      return f ? f.value.trim() : '';
    }

    function buildRecap() {
      if (!recapRows) return;
      recapRows.textContent = '';

      panels.forEach(function (p, n) {
        if (n === total - 1) return;
        var v = answer(p);
        if (!v) return;

        var row = document.createElement('div');
        row.className = 'tnq__recap-row';

        var k = document.createElement('span');
        k.className = 'tnq__recap-k';
        k.textContent = label(p);

        var val = document.createElement('span');
        val.className = 'tnq__recap-v';
        val.textContent = v;

        var edit = document.createElement('button');
        edit.type = 'button';
        edit.className = 'tnq__recap-e';
        edit.textContent = 'Edit';
        edit.addEventListener('click', function () { i = n; paint(); });

        row.appendChild(k);
        row.appendChild(val);
        row.appendChild(edit);
        recapRows.appendChild(row);
      });
    }

    function paint() {
      panels.forEach(function (p, n) { p.classList.toggle('is-on', n === i); });

      if (stepEl) stepEl.textContent = 'Step ' + (i + 1) + ' of ' + total;
      if (fill) fill.style.width = (((i + 1) / total) * 100) + '%';
      if (back) back.hidden = (i === 0);

      next.textContent = isLast() ? sendLabel : 'Continue';
      next.disabled = !valid(cur());

      if (hint) {
        hint.style.visibility = (cur().querySelector('textarea') || isLast()) ? 'hidden' : 'visible';
      }

      if (isLast()) buildRecap();

      var f = cur().querySelector('input:not([type=hidden]), textarea');
      if (f && window.innerWidth > 620) {
        setTimeout(function () { f.focus(); }, 60);
      }
    }

    function go() {
      if (!valid(cur())) { next.disabled = true; return; }
      if (isLast()) { submit(); return; }
      i++;
      paint();
    }

    function goBack() { if (i > 0) { i--; paint(); } }

    form.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.tnq__choice') : null;
      if (!btn) return;

      var wrap = btn.closest('[data-tnq-choices]');
      var panel = btn.closest('[data-tnq-panel]');
      Array.prototype.slice.call(wrap.children).forEach(function (c) { c.classList.remove('is-sel'); });
      btn.classList.add('is-sel');

      var hidden = panel.querySelector('[data-tnq-value]');
      if (hidden) hidden.value = choiceText(btn);

      next.disabled = false;
      if (!showAll && !isLast()) setTimeout(go, 220);
    });

    form.addEventListener('input', function () { next.disabled = !valid(cur()); });

    form.addEventListener('keydown', function (e) {
      if (showAll) return;

      if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
        e.preventDefault();
        go();
        return;
      }

      var tag = e.target.tagName;
      if (/^[1-9]$/.test(e.key) && tag !== 'INPUT' && tag !== 'TEXTAREA') {
        var c = cur().querySelectorAll('.tnq__choice')[Number(e.key) - 1];
        if (c) c.click();
      }
    });

    next.addEventListener('click', go);
    if (back) back.addEventListener('click', goBack);

    if (allBtn) {
      allBtn.addEventListener('click', function () {
        showAll = !showAll;
        root.classList.toggle('is-all', showAll);
        allBtn.textContent = showAll ? 'Guide me through it' : 'See all questions';

        if (showAll) {
          next.textContent = sendLabel;
          next.disabled = false;
        } else {
          i = 0;
          paint();
        }
      });
    }

    function finish(ok) {
      if (!pending) return;
      pending = false;
      clearTimeout(timer);

      form.hidden = true;
      var top = root.querySelector('.tnq__top');
      var bar = root.querySelector('.tnq__bar');
      if (top) top.hidden = true;
      if (bar) bar.hidden = true;

      var panel = ok ? done : fail;
      if (panel) {
        panel.hidden = false;
        panel.setAttribute('tabindex', '-1');
        panel.focus();
      }
    }

    function submit() {
      var missing = panels.filter(function (p) { return !valid(p); });
      if (missing.length) {
        i = panels.indexOf(missing[0]);
        paint();
        return;
      }

      next.textContent = 'Sending…';
      next.disabled = true;
      pending = true;

      if (frame) {
        frame.addEventListener('load', function () { finish(true); }, { once: true });
      }

      timer = setTimeout(function () { finish(false); }, TIMEOUT_MS);

      form.submit();
    }

    paint();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-tnq]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme editor re-renders sections without a full page load.
  document.addEventListener('shopify:section:load', boot);
})();
